export default __webpack_public_path__ + "media/images/seestadt-aspern-luft-9726dd1e82a6ad3dce7b3041a57e2a47.jpg";